import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-driver-layout',
  templateUrl: './driver-layout.component.html',
  styleUrls: ['./driver-layout.component.scss']
})
export class DriverLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
